import { z } from 'zod';
import { MediaUnitFiltersSchema } from './media-units.js';

export const CampaignFilterPresetSchema = z.object({
  campaignId: z.number(),
  filters: MediaUnitFiltersSchema,
  updatedAt: z.string(),
});

export type CampaignFilterPreset = z.infer<typeof CampaignFilterPresetSchema>;
